<template>
  <ol class="steps">
    <li
      class="step"
      v-for="item in steps"
      :key="item.step"
      :data-step="item.step + 1"
      :class="[
        { 'is-complete': item.step < currentStep },
        { 'is-active': item.step === currentStep }
      ]"
    >
      <div v-if="item.text" class="step-text">{{ item.text }}</div>
    </li>
  </ol>
</template>

<script>
export default {
  name: '',
  props: {
    steps: {
      type: Array,
      required: true
    },
    currentStep: {
      type: Number,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
$complete: #409eff;
$active: #fff;
$mute: #409eff;
$static: #409eff;

.steps {
  list-style: none;
  margin: 30px auto;
  padding: 0;
  display: table;
  table-layout: fixed;
  width: 100%;
  color: #fff;

  > .step {
    position: relative;
    display: table-cell;
    text-align: center;
    color: #6d6875;

    &:before {
      content: attr(data-step);
      position: relative;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 30px;
      height: 30px;
      margin: 0 auto;
      background: $mute;
      border: 2px solid $mute;
      border-radius: 100%;
      color: #fff;
      font-size: 15px;
    }

    &:after {
      content: '';
      position: absolute;
      display: block;
      background: $static;
      width: 100%;
      height: 3px;
      top: 25%;
      left: 50%;
    }
    &:last-child:after {
      display: none;
    }
    &.is-complete {
      &:before {
        color: #fff;
        background: $complete;
        border: 2px solid $complete;
      }
      &:after {
        background: $complete;
      }
    }
    &.is-active {
      &:before {
        color: #000;
        border: 2px solid #000;
        background: $active;
      }
    }
  }
  .step-text {
    font-size: 8px;
    margin-top: 10px;
    color: #73879c;
  }
}

*,
*:after,
*:before {
  box-sizing: border-box;
}
</style>
